import {
	IconChartColumnFilled,
	IconChatFilled,
	IconFavoriteFilled,
	IconShortsWhite,
	IconViewFilled,
	IconYoutubeWhite,
} from '@featuring-corp/icons';
import { useTranslation } from 'react-i18next';
import React from 'react';
import CardGroupSection, {
	CardGroupItem,
} from '@components/report/card-group-section/CardGroupSection';

export type PickedCardProps = Pick<CardGroupItem, 'content' | 'disabled'>;

export interface KeyMetricsYtProps {
	averageViews?: PickedCardProps;
	averageVideoViews?: PickedCardProps;
	averageShortsViews?: PickedCardProps;
	averageLikes?: PickedCardProps;
	averageComments?: PickedCardProps;
	engagementRate?: PickedCardProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const KeyMetricsYt = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: KeyMetricsYtProps) => {
	const { t } = useTranslation('infReportYoutube');
	const status = { isLoading, isError, lackOfPermission };

	const cardGroup: CardGroupItem[] = [
		{
			label: t('features.report.section-content.yt.key-metrics.average-views.label'),
			subLabel: t(
				'features.report.section-content.yt.key-metrics.average-views.sublabel',
			),
			tooltip: t('features.report.section-content.yt.key-metrics.average-views.tooltip'),
			icon: IconViewFilled,
			...props.averageViews,
		},
		{
			label: t(
				'features.report.section-content.yt.key-metrics.average-video-views.label',
			),
			tooltip: t(
				'features.report.section-content.yt.key-metrics.average-video-views.tooltip',
			),
			icon: IconYoutubeWhite,
			...props.averageVideoViews,
		},
		{
			label: t(
				'features.report.section-content.yt.key-metrics.average-shorts-views.label',
			),
			tooltip: t(
				'features.report.section-content.yt.key-metrics.average-shorts-views.tooltip',
			),
			icon: IconShortsWhite,
			...props.averageShortsViews,
		},
		{
			label: t('features.report.section-content.yt.key-metrics.average-likes.label'),
			tooltip: t('features.report.section-content.yt.key-metrics.average-likes.tooltip'),
			icon: IconFavoriteFilled,
			...props.averageLikes,
		},
		{
			label: t('features.report.section-content.yt.key-metrics.average-comments.label'),
			tooltip: t(
				'features.report.section-content.yt.key-metrics.average-comments.tooltip',
			),
			icon: IconChatFilled,
			...props.averageComments,
		},
		{
			label: t('features.report.section-content.yt.key-metrics.engagement-rate.label'),
			tooltip: t(
				'features.report.section-content.yt.key-metrics.engagement-rate.tooltip',
			),
			icon: IconChartColumnFilled,
			...props.engagementRate,
		},
	];

	return <CardGroupSection cardGroup={cardGroup} {...status} />;
};

export default KeyMetricsYt;
